import { apiClient } from './client';
import { Categoria } from '../types';

export interface DadosCategoria {
  nome: string;
  ordem?: number;
  imagem_base64?: string | null;
  remover_imagem?: boolean;
}

export function listarCategorias(): Promise<Categoria[]> {
  return apiClient.get('/categorias').then((res) => res.data.categorias);
}

export function criarCategoria(dados: DadosCategoria): Promise<Categoria> {
  return apiClient.post('/categorias', dados).then((res) => res.data.categoria);
}

export function atualizarCategoria(id: number, dados: DadosCategoria): Promise<Categoria> {
  return apiClient.put(`/categorias/${id}`, dados).then((res) => res.data.categoria);
}

export function removerCategoria(id: number): Promise<{ ok: boolean }> {
  return apiClient.delete(`/categorias/${id}`).then((res) => res.data);
}
